<template>
  <div>
    <a-card class="customer-filter">
      <a-form-model :form="filterForm" :label-col="{ span: 6 }" :model="filterForm" class="search-form">
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-model-item label="标题">
              <a-input v-model="filterForm.release_title" allow-clear placeholder="发布评审标题" class="form-model-item" @change="handleChange" />
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item label="状态">
              <a-select v-model="filterForm.status" mode="multiple" placeholder="状态" allow-clear @change="handleChange">
                <a-select-option v-for="(item, key) in releaseStatus" :key="key" :value="item.value">
                  <a-badge :status="item.status" :text="item.label" />
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>

          <a-col :span="6">
            <a-form-model-item label="环境">
              <a-select v-model="filterForm.release_env" placeholder="环境" allow-clear @change="handleChange">
                <a-select-option v-for="(item, key) in releaseEnvs" :key="key" :value="item.value">
                  {{ item.label }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item v-show="expand" label="创建人">
              <user-select v-model="filterForm.creator" show-all mode="multiple" allow-clear show-search placeholder="创建人" :project-id="projectId" @change="handleChange" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item v-show="expand" :label-col="{ span: 3 }" label="时间">
              <a-input-group compact>
                <a-select v-model="filterForm.filter_key" style="width: 30%" @change="handleChange">
                  <a-select-option value="created"> 创建时间 </a-select-option>
                  <a-select-option value="submitted"> 提交时间 </a-select-option>
                  <a-select-option value="deployed"> 部署时间 </a-select-option>
                  <a-select-option value="completed"> 完成时间 </a-select-option>
                </a-select>
                <a-date-picker v-model="filterForm.start_date" allow-clear style="width: 35%" placeholder="开始时间" value-format="YYYY-MM-DD" @change="handleChange" />
                <a-date-picker v-model="filterForm.end_date" allow-clear style="width: 35%" placeholder="结束时间" value-format="YYYY-MM-DD" @change="handleChange" />
              </a-input-group>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item v-show="expand" label="关联需求">
              <a-select v-model="requirementValue" show-search allow-clear placeholder="关联需求" label-in-value :filter-option="false" :not-found-content="storySearching ? undefined : null" @search="searchStory" @change="handleStoryChange">
                <a-spin v-if="storySearching" slot="notFoundContent" size="small" />
                <a-select-option v-for="item in searchStoryData" :key="item.value" :value="item.value" :version="item.version">
                  {{ item.label }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item v-show="expand" label="标签">
              <a-select v-model="filterForm.tags" mode="multiple" show-search placeholder="发布评审标签" :filter-option="utils.filterOption" allow-clear @change="handleChange">
                <a-select-option v-for="(tag, index) in releaseTags" :key="index" :value="tag.id">
                  <span v-if="tag.name === '其他（请在备注信息添加原因）'">{{ tag.group_name }}:{{ tag.name }} </span>
                  <span v-else>{{ tag.name }}</span>
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item v-show="expand" label="类型">
              <a-select v-model="filterForm.release_type" allow-clear mode="multiple" placeholder="类型" @change="handleChange">
                <a-select-option v-for="item in releaseTypes" :key="item.value" :value="item.value">{{ item.label }}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="6" style="float: right; text-align: right">
            <a-button v-tc="{ name: '查询' }" type="primary" @click="getWorkflowReleaseList">查询</a-button>
            <a-button v-tc="{ name: '重置' }" :style="{ margin: '0 8px' }" @click="onReset">重置</a-button>
            <a v-tc="{ name: '展开/收起' }" class="ant-dropdown-link" @click="expand = !expand">{{ expand ? '收起' : '展开' }} <a-icon :type="expand ? 'up' : 'down'" /> </a>
          </a-col>
        </a-row>
      </a-form-model>
    </a-card>
    <a-card title="发布评审列表" class="filter-data">
      <a-table :scroll="{ x: 1500 }" :pagination="pagination" :columns="columns" size="middle" :data-source="tableData" row-key="release_id" :loading="loading" @change="handlePageChange">
        <template slot="creator" slot-scope="text, record">
          <user-profiles :value="[record.creator.user_id]" avatar />
        </template>
        <span slot="releaseTitle" slot-scope="text, record">
          <a-tooltip placement="topLeft" :title="record.release_title">
            <a v-tc="{ name: '跳转发布评审详情' }" class="custom-link" :href="releaseLink(record)"> {{ record.release_title }} </a>
          </a-tooltip>
        </span>
        <span slot="workflowTitle" slot-scope="text, record">
          <a-tooltip placement="topLeft" :title="record.workflow_title">
            <a v-tc="{ name: '跳转流程详情' }" class="custom-link" :href="workflowLink(record)"> {{ record.workflow_title }} </a>
          </a-tooltip>
        </span>
        <span slot="releseType" slot-scope="text, record">
          {{ record.release_type.label }}
        </span>
        <span slot="releaseEnv" slot-scope="text, record">
          {{ record.release_env.label }}
        </span>
        <span slot="status" slot-scope="text, record">
          <a-badge :status="releaseStatus[record.status].status" :text="releaseStatus[record.status].label" />
        </span>
        <span slot="tags" slot-scope="text, record">
          <a-popover placement="topLeft">
            <template slot="content">
              <a-tag v-for="(tag, index) in record.tags" :key="index" :color="tag.color">{{ tag.name }}</a-tag>
            </template>
            <template slot="title">
              <span>标签</span>
            </template>
            <a-tag v-for="(tag, index) in record.tags" :key="index" :color="tag.color">{{ tag.name }}</a-tag>
          </a-popover>
        </span>
      </a-table>
    </a-card>
  </div>
</template>

<script>
import { tagList } from '@/api/system/tag';
import { storySearch } from '@/api/project/story';
import { workflowReleaseList } from '@/api/project/workflow';
import { releaseStatus, releaseEnvs, releaseTypes } from '@/utils/dictionary';

import UserSelect from '@/components/User/UserSelect';

const columns = [
  {
    width: 60,
    title: 'ID',
    fixed: 'left',
    key: 'release_id',
    dataIndex: 'release_id'
  },
  {
    width: 300,
    title: '标题',
    fixed: 'left',
    ellipsis: true,
    scopedSlots: { customRender: 'releaseTitle' }
  },
  {
    width: 240,
    title: '流程',
    fixed: 'left',
    ellipsis: true,
    scopedSlots: { customRender: 'workflowTitle' }
  },
  {
    width: 100,
    title: '关联类型',
    key: 'issue_type',
    dataIndex: 'issue_type',
    customRender: record => {
      return record.join(', ') || '--';
    }
  },
  {
    width: 100,
    title: '环境',
    key: 'relese_env',
    dataIndex: 'relese_env',
    scopedSlots: { customRender: 'releaseEnv' }
  },
  {
    width: 180,
    title: '提交时间',
    key: 'submission_time',
    dataIndex: 'submission_time'
  },
  {
    width: 180,
    title: '部署时间',
    key: 'deployed_time',
    dataIndex: 'deployed_time'
  },
  {
    width: 180,
    title: '完成时间',
    key: 'completed_time',
    dataIndex: 'completed_time'
  },
  {
    width: 150,
    key: 'tags',
    title: '标签',
    ellipsis: true,
    dataIndex: 'tags',
    scopedSlots: { customRender: 'tags' }
  },
  {
    width: 110,
    title: '创建人',
    key: 'creator',
    dataIndex: 'creator',
    scopedSlots: { customRender: 'creator' }
  },
  {
    width: 180,
    title: '创建时间',
    key: 'created_time',
    dataIndex: 'created_time'
  },
  {
    title: '状态',
    key: 'status',
    width: 100,
    fixed: 'right',
    dataIndex: 'status',
    scopedSlots: { customRender: 'status' }
  }
];

export default {
  components: { UserSelect },
  data() {
    return {
      releaseEnvs,
      releaseTypes,
      releaseStatus,
      projectId: parseInt(this.$route.params.project_id) || null,
      filterForm: {
        release_title: null,
        release_type: [],
        filter_key: 'created',
        start_date: null,
        end_date: null,
        project_id: parseInt(this.$route.params.project_id) || null,
        page_size: 20,
        page_number: 1
      },
      loading: false,
      pagination: {
        size: 'large',
        total: 0,
        current: 1,
        pageSize: 20, // 每页中显示20条数据
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'], // 每页中显示的数据
        showTotal: total => `共 ${total} 条` // 分页中显示总的数据
      },
      expand: true,
      tableData: [],
      columns,
      requirementValue: {},
      storySearching: false,
      searchStoryData: [],
      releaseTags: []
    };
  },
  computed: {
    count() {
      return this.expand ? 11 : 7;
    },
    releaseLink() {
      return record => {
        const link = this.$router.resolve({
          name: 'page:project:workflow:release:detail',
          query: { releaseId: record.release_id }
        });
        return link.href;
      };
    },
    workflowLink() {
      return record => {
        const link = this.$router.resolve({
          name: 'page:project:workflow:detail',
          query: { workflowId: record.workflow_id }
        });
        return link.href;
      };
    }
  },
  mounted() {
    this.getReleaseTagList();
    this.getWorkflowReleaseList();
  },
  methods: {
    getReleaseTagList() {
      tagList({ group_code_list: ['release_rejected', 'release_returned', 'release_canceled'] }).then(res => {
        this.releaseTags = res.data.items;
      });
    },
    // 需求搜索
    searchStory(value) {
      storySearch({ project_id: this.projectId, value: value }).then(res => {
        this.searchStoryData = res.data.items;
      });
    },
    handleStoryChange(value, option) {
      if (value) {
        this.filterForm.requirement_id = value.key;
      } else {
        this.filterForm.requirement_id = null;
      }
      this.handleChange();
    },

    handleChange() {
      this.pagination.current = 1;
      this.filterForm.page_number = 1;
      this.getWorkflowReleaseList();
    },

    // 点击重置
    onReset() {
      this.filterForm = {
        release_title: null,
        release_type: [],
        filter_key: 'created',
        start_date: null,
        end_date: null,
        project_id: parseInt(this.$route.params.project_id) || null,
        page_size: 20,
        page_number: 1
      };
      this.pagination.current = 1;
      this.pagination.pageSize = 20;
      this.getWorkflowReleaseList();
    },

    toggle() {
      this.expand = !this.expand;
    },

    // 获取发布评审列表
    getWorkflowReleaseList() {
      this.loading = true;
      workflowReleaseList(this.filterForm)
        .then(res => {
          this.tableData = res.data.items;
          this.pagination.total = res.data.total;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    handlePageChange(pagination) {
      this.pagination = pagination;
      this.filterForm.page_size = pagination.pageSize;
      this.filterForm.page_number = pagination.current;
      this.getWorkflowReleaseList();
    },

    // 关闭弹窗
    close() {
      this.getWorkflowReleaseList();
    }
  }
};
</script>

<style lang="less">
.customer-filter {
  margin-bottom: 16px;
}

.handle-menu {
  margin: 0 5px;
}
.search-form .ant-form-item {
  display: flex;
}

.search-form .ant-form-item-control-wrapper {
  flex: 1;
  width: 71%;
}
</style>
<style lang="less" scoped>
.ant-form-item {
  margin-bottom: 0;
}
.custom-link {
  color: rgba(0, 0, 0, 0.65);
}
.custom-link:hover {
  color: #1890ff;
}

/deep/.ant-radio-button-wrapper {
  padding: 0 12px;
}
</style>
